import React from 'react';
import '../App.css'; // Correct relative path

const Header = () => (
  <div className="header">
    <h1>🚀 Join Us as a Full Stack Developer Expert!</h1>
    <p>
      Are you ready to make a lasting impact in the world of tech? Become a Full Stack Developer Expert and help shape the future of aspiring developers.
    </p>
    <p>
      At Indian Developers Group, we’re on a mission to empower the next generation of developers. As an expert, you’ll have the opportunity to share your knowledge, mentor eager learners, and be a part of their journey toward mastering full-stack development.
    </p>
    <p>
      By joining our team, you’ll be able to:
    </p>
    <ul>
      <li>Guide students through dynamic, hands-on projects and real-world coding challenges</li>
      <li>Impart valuable industry insights, tips, and best practices</li>
      <li>Collaborate with a community of passionate educators and professionals</li>
      <li>Enhance your own career and grow your professional network</li>
    </ul>
    <p>
      Ready to inspire, mentor, and make a difference? Join us today and help mold the future of the tech industry!
    </p>
  </div>
);

export default Header;
